import { render, staticRenderFns } from "./USplitModal.vue?vue&type=template&id=789573a8&scoped=true&"
import script from "./USplitModal.vue?vue&type=script&lang=js&"
export * from "./USplitModal.vue?vue&type=script&lang=js&"
import style0 from "./USplitModal.vue?vue&type=style&index=0&id=789573a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789573a8",
  null
  
)

export default component.exports